import React, { HTMLAttributes } from 'react';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { AssistiveText } from '../AssistiveText';
import classNames from 'classnames';

export type DescriptionProps = HTMLAttributes<HTMLDivElement> & {
    description?: string;
};

export const Description: FunctionComponent<DescriptionProps> = ({
    description,
    className,
    ...props
}) => {
    if (!description) {
        return null;
    }

    return (
        <AssistiveText {...props} className={classNames(styles.description, className)}>
            {description}
        </AssistiveText>
    );
};
